<main id="main">
  @if (canShowContent()) {
    <router-outlet />
  }
  @if (isLoading()) {
    <thalea-page-loader />
  }
</main>

<!-- Global toaster - automatically handles all HTTP request notifications -->
<hlm-toaster position="top-right" [duration]="1000" />
